import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  pages: [
    {
      path: '/fire-safety/inspections',
      load: () => import('./inspections-page'),
      permission: 'fire-safety.inspection.read',
    },
    {
      path: '/fire-safety/inspections/$id',
      load: () => import('./inspection-page'),
      permission: 'fire-safety.inspection.read',
    },
  ],
  documents: {
    'fire-safety.inspection-report': () => import('./documents/inspection-report'),
  },
  recordSections: [
    {
      key: 'fire-safety.object-inspections',
      load: () =>
        import('./inspections-section').then((m) => ({ default: m.ObjectInspectionsSection })),
    },
    {
      key: 'fire-safety.project-inspections',
      load: () =>
        import('./inspections-section').then((m) => ({ default: m.ProjectInspectionsSection })),
    },
  ],
  guides: [
    {
      id: 'fire-safety.inspections',
      title: 'fire-safety.guides.inspections.title',
      summary: 'fire-safety.guides.inspections.summary',
      pages: ['/fire-safety/inspections', '/fire-safety/inspections/$id'],
      content: {
        de: () => import('./guides/inspections.de.md?raw'),
        en: () => import('./guides/inspections.en.md?raw'),
      },
    },
  ],
});
